<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@if (!showDefault) {
  <div>
    <div
      class="selected-icon {{ iconSettings.selected?.color }} {{
        iconSettings.selected?.glyph
      }}  text-center align-middle"
      [ngClass]="iconSize == 0 ? 'small xglsize-24' : 'xglsize-64'"></div>
    <div class="color-list-wrapper web-portal">
      <div class="color-list web-portal">
        @for (group of colorList; track group) {
          <div class="xrx-seg-control colors" role="tablist" aria-label="...">
            @for (option of group; track option) {
              <button
                type="button"
                class="xrx-btn btn-secondary xglsize-24 web-portal {{ option }}"
                [ngClass]="{
                  'selected xgl-checkmark_circle_alt':
                    iconSettings.selected?.color === option,
                }"
                (click)="select(option, true)"></button>
            }
          </div>
        }
      </div>
    </div>
    <div class="glyph-list-wrapper web-portal">
      <div class="glyph-list web-portal">
        @for (group of iconList; track group) {
          <div class="xrx-seg-control glyphs" role="tablist" aria-label="...">
            @for (option of group; track option) {
              <button
                type="button"
                class="xrx-btn btn-secondary web-portal {{ option }} {{
                  iconSettings.selected?.glyph === option
                    ? iconSettings.selected?.color + ' selected'
                    : ''
                }}"
                (click)="select(option)"></button>
            }
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  @if (originalIcon?.image) {
    <img
      class="workflow-image"
      [src]="originalIcon?.image"
      [ngClass]="{ small: iconSize == 0 }" />
  } @else {
    <div class="d-inline-block">
      <div
        class="workflow-image {{ originalIcon?.glyph }} {{
          originalIcon?.color
        }} xglsize-64 text-center align-middle"></div>
    </div>
  }
}
